<div class="table-row">
  <div class="table-cell image-cell">
    <div class="product-image-small">
      <img
        *ngIf="hasProductImage()"
        [src]="getProductImageUrl()"
        [alt]="item.productName || 'Produto'"
        class="small-image"
        (error)="$event.target.style.display = 'none'"
      />
      <div *ngIf="!hasProductImage()" class="no-image-small">
        <i class="pi pi-image"></i>
      </div>
    </div>
  </div>
  <div class="table-cell name-cell">
    <div class="product-name-summary">
      {{ item.productName || 'Nome não disponível' }}
    </div>
    <div *ngIf="item.variantSummary" class="variant-name-summary">
      {{ item.variantSummary }}
    </div>
  </div>
  <div class="table-cell quantity-cell">
    <span *ngIf="item.productQuantity" class="quantity-value">{{
      item.productQuantity
    }}</span>
    <span *ngIf="!item.productQuantity" class="no-data">-</span>
  </div>
  <div class="table-cell sku-cell">
    <div class="value-with-copy-small" *ngIf="canCopyValue(item.externalId)">
      <span>{{ item.externalId }}</span>
      <p-button
        icon="pi pi-copy"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="copyToClipboard(item.externalId, 'SKU')"
        pTooltip="Copiar SKU"
      />
    </div>
    <div *ngIf="item.externalId && !canCopyValue(item.externalId)">
      <span>{{ item.externalId }}</span>
    </div>
    <span *ngIf="!item.externalId" class="no-data">-</span>
  </div>
  <div class="table-cell ean-cell">
    <div class="value-with-copy-small" *ngIf="canCopyValue(item.productEAN)">
      <span>{{ item.productEAN }}</span>
      <p-button
        icon="pi pi-copy"
        severity="secondary"
        size="small"
        [text]="true"
        (onClick)="copyToClipboard(item.productEAN, 'EAN')"
        pTooltip="Copiar EAN"
      />
    </div>
    <div *ngIf="item.productEAN && !canCopyValue(item.productEAN)">
      <span>{{ item.productEAN }}</span>
    </div>
    <span *ngIf="!item.productEAN" class="no-data">-</span>
  </div>
</div>
